<template>
  <vue-dropzone
    id="uploader"
    ref="uploader"
    :awss3="awss3"
    :duplicate-check="true"
    :options="dropzoneOptions"
    :destroy-dropzone="true"
    :class="customClass"
    @vdropzone-s3-upload-error="s3UploadError"
    @vdropzone-s3-upload-success="s3UploadSuccess"
    @vdropzone-removed-file="onFileRemoved"
    @vdropzone-canceled="onFileRemoved"
  />
</template>
<script>
import vue2Dropzone from 'vue2-dropzone'
import { getToken } from '@/helpers'

import 'vue2-dropzone/dist/vue2Dropzone.min.css'
let status = ''
export default {
  name: 'S3Uploader',
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    type: {
      type: String,
      required: false,
      default: 'temp',
    },
    objectId: {
      type: String,
    },
    maxFiles: {
      type: Number,
      default: null,
    },
    autoUpload: {
      type: Boolean,
      default: false,
    },
    path: {
      type: String,
      default: 'temp',
    },
  },
  data: function () {
    return {
      status: '',
    }
  },
  computed: {
    dropzoneOptions() {
      return {
        maxFiles: this.maxFiles,
        url: '/',
        addRemoveLinks: true,
        autoProcessQueue: this.autoUpload,
        maxFilesize: 10,
        dictCancelUpload: this.$t('titles.dropzone.dictCancelUpload'),
        dictCancelUploadConfirmation: this.$t(
          'titles.dropzone.dictCancelUploadConfirmation'
        ),
        dictRemoveFile: this.$t('titles.dropzone.dictRemoveFile'),
        dictMaxFilesExceeded: this.$t('titles.dropzone.dictMaxFilesExceeded'),
        dictResponseError: this.$t('titles.dropzone.dictResponseError'),
        dictInvalidFileType: this.$t('titles.dropzone.dictInvalidFileType'),
        dictFileTooBig: this.$t('titles.dropzone.dictFileTooBig'),
        dictDefaultMessage: this.$t('titles.dropzone.dictDefaultMessage'),
      }
    },
    awss3() {
      return {
        signingURL: (f) => {
          return (
            process.env.VUE_APP_API_URL +
            'upload/s3?filename=' +
            this.path +
            '/' +
            f.name
          )
        },
        headers: {
          Authorization: 'Bearer ' + getToken(),
        },
        sendFileToServer: false,
        withCredentials: false,
      }
    },
    customClass() {
      if (status == 'success') return 'successUpload'
      else if (status == 'error') return 'errorUpload'
      return ''
    },
  },
  methods: {
    s3UploadError(errorMessage) {
      console.log('s3UploadError: ' + errorMessage)
    },
    s3UploadSuccess(s3ObjectLocation) {
      this.$emit('uploadSuccess', decodeURIComponent(s3ObjectLocation))
    },
    onFileRemoved(file) {
      if (!file) return
      this.$emit('onFileRemoved', file.s3Signature.Key)
    },
    processQueue() {
      this.$nextTick(() => {
        this.$refs.uploader.processQueue()
      })
    },
  },
}
</script>
<style lang="scss">
.vue-dropzone > .dz-preview .dz-details {
  background-color: var(--v-primary-base);
}
.successUpload > .dz-preview .dz-details {
  background-color: var(--v-primary-base) !important;
}
.errorUpload > .dz-preview .dz-details {
  background-color: var(--v-error-base) !important;
}
</style>
